import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Another from './components/Another';
import Amenitie from './components/Amenitie';
import ContactForm from './components/Contact';
import Footer from './components/Footer';
import Footer1 from './components/Footer1';
import LocomotiveScroll from 'locomotive-scroll';
import Homeplan from './components/Homeplan';
import Whatsapp from './components/Whatsapp';



function App() {
  const locomotiveScroll = new LocomotiveScroll();
  return (
    <>
      <Navbar />
      
      {/* Sections with matching IDs */}
      <Home id="home" />
      <Homeplan />
      <Whatsapp />
      <About id="about" />
      <Another id="project" />
      <Amenitie id="amenities" />
      <ContactForm id="contact" />
      
      <Footer />
      <Footer1 />
    </>
  );
}

export default App;
